import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.response.use(
  response => response,
  error => {
    // if (error.response.status === 401) {
    //   toast.error('Your session is invalidated. Please login again!!');
    //   setTimeout(() => (window.location.href = '/'), 2000);
    // }
    return Promise.reject(error);
  },
);

export default instance;
